<h5 class="detail-steps__title mb-4">{{packet.title}}</h5>
<div class="detail-content__row">
  <div class="detail-steps">
    <div class="detail-steps__description detail-steps__text" [innerHTML]="packet.description"></div>
  </div>
</div>
